if(!customElements.get('swym-wishlist-page')){
    class SwymWishlistPage extends HTMLElement{
        constructor(){
            super();
            this._initializeSwymComponent();
        }

        _init(swat){
            this._initializeSelectors(swat);
            this.isShareWishlistPage ? this._renderShareWishlist(swat) : this._renderWishlist(swat);
            this._attachEventListeners();
        }

        /* General funcions */

        _initializeSwymComponent(){
            if (!window.SwymCallbacks) window.SwymCallbacks = [];
            window.SwymCallbacks.push(this._init.bind(this));
        }

        _initializeSelectors (swat){
            this.swat = swat;
            this.body = document.body;
            this.settings = JSON.parse(this.dataset.settings);
            this.isShareWishlistPage = window.isShareListPage;

            /* Page Header Selectors */ 

            this.accountButton = this.querySelector('#swymcs-user-login-status-btn');
            this.accountPopup = this.querySelector('#swymcs-user-login-status-popup');
            this.accountPopupCloseButton = this.querySelector('#swymcs-close-account-popup');
            this.accountPopupCancelButton = this.querySelector('#swymcs-cancel-account-popup');
            this.accountPopupActionButton = this.querySelector('#swymcs-account-login-action-button');

            /* Wishlist grid container */
            this.emptyListContainer = this.querySelector('#swym-empty-wishlist-container'); 
            this.wishlistContainer = this.querySelector('#swymcs-wishlist-container');
            this.listsContainer = this.querySelector('#swymcs-lists-grid');
            this.listProductsContainer = this.querySelector('#swymcs-products-grid-container');
            this.productsContainer = this.querySelector('#swymcs-products-grid');
            this.wishlistHeader = this.querySelector('#swymcs-wishlist-header');
            this.backToListView = this.querySelector('#swymcs-back-to-lists-view');

            /* Lists header selectors */
            this.activeListContainer = this.querySelector('#swymcs-active-list');
            this.activeListImage = this.querySelector('#swymcs-active-list-image');
            this.activeListImageText = this.querySelector('#swymcs-active-list-image-text');
            this.activeListTilte = this.querySelector('#swymcs-active-list-title');
            this.activeListItemCount = this.querySelector('#swymcs-active-list-item-count');
            this.headerListsContainer = this.querySelector('#swymcs-header-lists');

            /* Additional Options selectors */ 

            this.additionalOptionsContainer = this.querySelector('#swymcs-additional-options');
            this.additionalOptionsBtn = this.querySelector('#swymcs-view-additional-options');
            this.shareListButton = this.querySelector('#swymcs-share-list');
            this.renameListButton = this.querySelector('#swymcs-rename-list');
            this.duplicateListButton = this.querySelector('#swymcs-duplicate-list');
            this.deleteListButton = this.querySelector('#swymcs-delete-list');

            /* Additional Options popup selectors */
            this.additionalOptionsPopupContainer = this.querySelector('#swymcs-additional-options-popup-container');
            this.additionalOptionsPopupCloseButton = this.querySelector('#swymcs-close-additional-popup');
            this.additionalPopupCancelButtons = this.querySelectorAll('.swymcs-additonal-popup-cancel-button');

                /* Share List popup selectors */ 
                this.shareListPopup = this.querySelector('#swymcs-share-list-popup');
                this.shareLinkField = this.querySelector('#swymcs-share-link-field');
                this.shareNameField = this.querySelector('#swymcs-share-name-field');
                this.shareEmailField = this.querySelector('#swymcs-share-email-field');
                this.shareMessageField = this.querySelector('#swymcs-share-message-field');
                this.shareListError = this.querySelector('#swymcs-share-email-field-error');
                this.shareListButton = this.querySelector('#swymcs-confirm-share-list');
                this.copyLinkButton = this.querySelector('#swymcs-confirm-share-list--copy');
                this.facebookShareButton = this.querySelector('#swymcs-confirm-share-list--facebook');
                this.twitterShareButton = this.querySelector('#swymcs-confirm-share-list--twitter');
                
                /* Delete List popup selectors */ 
                this.deleteListPopup = this.querySelector('#swymcs-delete-list-popup');
                this.deleteListName = this.querySelector('#swymcs-confirm-delete-list-name');
                this.confirmDeleteListButton = this.querySelector('#swymcs-confirm-delete-list'); 
                
                /* Rename List popup selectors */ 
                this.renameListPopup = this.querySelector('#swymcs-rename-list-popup');
                this.renameListName = this.querySelector('#swymcs-confirm-rename-list-name');
                this.renameListError = this.querySelector('#swymcs-rename-list-error');
                this.renameListTextField = this.querySelector('#swymcs-rename-list-field')
                this.confirmRenameListButton = this.querySelector('#swymcs-confirm-rename-list'); 

                /* Duplicate List popup selectors */ 
                this.duplicateListPopup = this.querySelector('#swymcs-duplicate-list-popup');
                this.duplicateListName = this.querySelector('#swymcs-confirm-duplicate-list-name');
                this.duplicateListError = this.querySelector('#swymcs-duplicate-list-error');
                this.duplicateListTextField = this.querySelector('#swymcs-duplicate-list-field');
                this.confirmDuplicateListButton = this.querySelector('#swymcs-confirm-duplicate-list'); 
        }

        _attachEventListeners(){

            this.body.addEventListener('click', evt => this._overlayEvent(evt));

            /* Adding events to page header elements */ 

            this.accountButton.addEventListener('click', evt => this._showPopupContainer(this.accountPopup));
            this.accountPopupCloseButton.addEventListener('click', evt => this._hidePopupContainer(this.accountPopup));
            this.accountPopupCancelButton.addEventListener('click', evt => this._hidePopupContainer(this.accountPopup));
            this.accountPopupActionButton.addEventListener('click', this._loginButtonAction.bind(this));

            /* Header Lists Events */
            
            this.activeListContainer.addEventListener('click', evt => this._showPopupContainer(this.headerListsContainer));
            this.headerListsContainer.addEventListener('click', this._switchListsFromHeader);

            /* Additional Options Events */     
            this.additionalOptionsBtn.addEventListener('click', evt => this._showPopupContainer(this.additionalOptionsContainer));   
            this.additionalOptionsContainer.addEventListener('click', this._renderAdditionalOptionsPopup);

            /* Additional Options Popup Events */
            this.additionalPopupCancelButtons.forEach(btn => btn.addEventListener('click', this._closeAdditionalOptionsPopup.bind(this)));
            this.additionalOptionsPopupCloseButton.addEventListener('click', this._closeAdditionalOptionsPopup.bind(this));
             
                /* Share List Events */
                this.copyLinkButton.addEventListener('click', this._shareListByCopy.bind(this));
                this.shareListButton.addEventListener('click', this._shareListByEmail.bind(this));
                this.facebookShareButton.addEventListener('click', evt => this._shareListOnPlatform('facebook'));
                this.twitterShareButton.addEventListener('click', evt => this._shareListOnPlatform('twitter'));
                this.shareEmailField.addEventListener('input', this._validateEmail.bind(this));

                /* Rename List Events */
                this.confirmRenameListButton.addEventListener('click', this._renameList.bind(this));
                this.renameListTextField.addEventListener('input', evt => this._validateListName(
                    this.renameListTextField.value.trim().toLowerCase(),
                    this.renameListError
                ))

                /* Duplicate List Events */
                this.confirmDuplicateListButton.addEventListener('click', this._duplicateList.bind(this));
                this.duplicateListTextField.addEventListener('input', evt => this._validateListName(
                    this.duplicateListTextField.value.trim().toLowerCase(),
                    this.duplicateListError
                ))

                /* Delete List Events */ 
                this.confirmDeleteListButton.addEventListener('click', this._deleteList.bind(this));

            /* Lists grid buttons */
            this.listsContainer.addEventListener('click', this._showListDetails);
            this.productsContainer.addEventListener('click', this._eventsForProductsGrid);
            this.productsContainer.addEventListener('change', this._eventsForProductsGrid);
            this.backToListView.addEventListener('click', this._triggerBackToListView.bind(this));
            !this.isShareWishlistPage && this._manageDragEvent();
        }

        async _triggerBackToListView(){
            if(window.productsDraged) await this._updateProductSequenceOfCurrentList();
            this._renderWishlist(_swat);
        }

        async _updateProductSequenceOfCurrentList(){
            const sequence = [];
            this.productsContainer.querySelectorAll('li').forEach((item, index) => {
                const obj = {'epi': item.dataset.epi, 'index': index + 1};
                sequence.push(obj);
            })
            const updatedSequence = await this._updateProductSequenceInList(sequence);
            console.log(updatedSequence, 'updatedSequence');
            await swymCustomFunctions._updateProductsCprops(updatedSequence, window.currentActiveListId);
        }

        _showListDetails(evt){
            const target = evt.target;
            const page = document.querySelector('swym-wishlist-page');
            if(target.getAttribute('id') != 'swymcs-lists-grid'){
                const lid = evt.target.closest('.swymcs-list-item').dataset.lid;
                const action = target?.dataset?.action || 'view-list';
                if(target.classList.contains('swymcs-view-list-button') && action == 'shop')
                    location.href = '/';
                else 
                page._renderListProducts(lid);   
            } return;  
        }
        
        async _renderWishlist(){
            this.lists = await this._getLists();
            this.lists.length ? this._renderWishlists() : this._renderEmptyState();
        }

        async _renderShareWishlist(){
            this._hideContainer(this.querySelector('.swymcs-page-header'));
            const params = new URL(document.location).searchParams;
            const lid = params.get("lid");
            if(!lid){
                this._renderProductsGrid([], []);
                this._hideContainer(this.wishlistHeader);
                this._hideContainer(this.backToListView)
                this._showContainer(this.wishlistContainer);
                this._showContainer(this.listProductsContainer);
                return;
            }
            const listContents = await this._getProductsFromList(lid);
            const wishlistProducts = swymCustomFunctions._getSortedProducts(listContents);
            const shopifyProductsData = await this._getShopifyProductsData(wishlistProducts);
            await this._renderSharedListHeader(lid);
            this._renderProductsGrid(shopifyProductsData, wishlistProducts);
            this._hideContainer(this.backToListView)
            this._showContainer(this.wishlistContainer);
            this._showContainer(this.listProductsContainer);
        }

        _renderWishlists() {
            this._renderListsView();
            this.emptyListContainer.classList.add('swym-hide-container');
            this.wishlistContainer.classList.remove('swym-hide-container');
        }

        _renderEmptyState(){
            this.emptyListContainer.classList.remove('swym-hide-container');
            this.wishlistContainer.classList.add('swym-hide-container');
        }

        async _renderListsView(){
            window.currentActiveListId = '';
            let html = ``;
            this.lists.forEach(list => {
                const unsortedListContent = list?.listcontents || [];
                const listContents = swymCustomFunctions._getSortedProducts(unsortedListContent);

                let buttonText = !listContents.length ? 'Continue Shopping' : 'View';
                let buttonAction = !listContents.length ? 'shop' : 'view-list';
                let imageHtml = `<div class="swymcs-list-image-container">`;
                if(listContents.length){
                    for(let i = 0; i < 4; i++){
                        imageHtml += `
                            <div class="swymcs-wishlist-image-wrapper">
                                ${listContents[i] ? `<img src="${listContents[i].iu}" alt="${listContents[i].dt}" class="swymcs-wishlist-image"/>` : '<span class="swymcs-empty-image-container">&nbsp;</span>'}
                            </div>${i==3 ? '</div>' : ''}
                        `; 
                    }
                }
                else imageHtml += ` <p class="swymcs-no-products-message">This is an empty list!</p></div>`;

                html += `
                    <button class="swymcs-button swymcs-list-item swymcs-wishlist-grid-item" data-lid="${list.lid}" aria-label="View list ${list.lname}" id="list--${list.lid}">
                        <div class="swymcs-list-title-container">
                            <div class="swymcs-list-title">${list.lname}</div>
                        </div>
                        <div class="swymcs-list-product-count-container">
                            <span class="swymcs-product-count">${listContents.length}</span>
                            <span class="swymcs-product-count-text">${listContents.length > 1 ? 'products' : 'product'}</span>
                        </div>
                        ${imageHtml}
                        <div class="swymcs-view-list-button swymcs-major-button" data-action="${buttonAction}" id="swymcs-view-list-button-${list.lid}" aria-label="${buttonText}">
                            ${buttonText}
                        </div>
                    </button>
                `;
            });
            this.listsContainer.innerHTML = html;
            this._showContainer(this.listsContainer);
            this._hideContainer(this.listProductsContainer);
            this._scrollToTop();
        }

        async _renderListProducts(lid){
            window.currentActiveListId = lid;
            const unsortedListContent = await this._getProductsFromList(lid);
            const wishlistProducts = swymCustomFunctions._getSortedProducts(unsortedListContent);
            const shopifyProductsData = await this._getShopifyProductsData(wishlistProducts);
            this._renderListHeader(lid);
            this._renderProductsGrid(shopifyProductsData, wishlistProducts);
            this._hideContainer(this.listsContainer);
            this._showContainer(this.listProductsContainer);
        }

        async _renderSharedListHeader(lid){
            this.wishlistHeader.style.borderTop = '1px solid #c4c4c4';
            const activeList = await this._getListDetails(lid);
            this._renderActiveList(activeList.list);
            this.activeListContainer.style.pointerEvents = 'none';
            this._hideContainer(this.additionalOptionsBtn);
        }

        _renderListHeader(lid){
            const lists = this.lists; 
            const activeList = lists.find(list => list.lid == lid);
            this._renderActiveList(activeList);
            let html = ``;
            lists.forEach((list, index) => {
                const unsortedListContent = list?.listcontents || [];
                const listContents = swymCustomFunctions._getSortedProducts(unsortedListContent);
                if(listContents.length){
                    html += `
                    <li class="swymcs-header-list-item" data-lid="${list.lid}">
                        <img src="${listContents[0].iu}" alt="listContents[0].dt"/>
                        <span class="swym-list-item">${list.lname}</span>
                    </li>`
                }else {
                    html += `
                    <li class="swymcs-header-list-item" data-lid="${list.lid}">
                        <span class="swymcs-list-item-image-text">${list.lname[0]}</span>
                        <span class="swymcs-list-item">${list.lname}</span>
                    </li>`
                }
            })
            this.headerListsContainer.innerHTML = html;
        }

        _renderActiveList(list){
            const unsortedListContent = list?.listcontents || [];
            const listContent = swymCustomFunctions._getSortedProducts(unsortedListContent);
            this.activeListTilte.textContent = list.lname;
            this.activeListItemCount.textContent = `(${listContent.length})`;
            if(listContent.length){
                this.activeListImage.src = listContent[0].iu;
                this.activeListImage.alt = listContent[0].lname;
                this._hideContainer(this.activeListImageText);
                this._showContainer(this.activeListImage);
            }else {
                this.activeListImageText.textContent = list.lname[0];
                this.activeListImage.alt = listContent.lname;
                this._hideContainer(this.activeListImage);
                this._showContainer(this.activeListImageText);
            }
        }

        _renderProductsGrid(shopifyProducts, wishlistProducts){
            if(!wishlistProducts.length) {
                this._renderEmptyList();
                return;
            }
            window.productsDraged = false;
            let productMarkup = ``;
            wishlistProducts.forEach((pdp, index) => {
                const product = shopifyProducts[index];
                const selectedVariant = product.variants.find(variant => variant.id === pdp.epi);
                const sampleVariant = product.variants[1];
                const addToCartBtnText = selectedVariant.available ? (_swat.platform.isInDeviceCart(selectedVariant.id) ? `${this.settings.added_to_cart_text}` : `${this.settings.add_to_cart_text}`) : `${this.settings.sold_out_text}`;
                const inCart = _swat.platform.isInDeviceCart(selectedVariant.id) ? 'swymcs-product-in-cart' : '';
                const isSampleInCart = _swat.platform.isInDeviceCart(sampleVariant.id) ? 'swymcs-product-in-cart' : '';
                const lid = pdp.lid;
                const isSoldOut = !selectedVariant.available ? 'swymcs-sold-out' : '';
                const imageSrc = selectedVariant?.featured_image?.src || product?.featured_image ||  pdp.iu; 
                const sampleVariantHtml = sampleVariant ? `<button ${sampleVariant.available ? '': 'disabled'} data-purpose="cart" data-du="${pdp.du}" data-epi="${sampleVariant.id}" data-empi="${product.id}" class="${isSampleInCart} ${sampleVariant.available ? '': 'swymcs-sold-out'} swymcs-sample-product swymcs-button" aria-label="Add ${sampleVariant.title} to cart.">${this.settings.sample_add_to_cart_icon}<span class="swymcs-tooltip">${this.settings.sample_tooltip_text}</span></button>` : '';
                productMarkup += `
                    <li class="swymcs-wishlist-grid-item-container" data-index="${pdp?.cprops?.index}" id="wishlist-grid-item--${index}" data-url="${pdp.du}" data-lid="${lid}" data-epi="${pdp.epi}">
                        <div aria-labelledby="${product.title}" role="button" tabindex="0" class="swymcs-wishlist-grid-item swymcs-wishlist-item swymcs-list-product">
                            <span id="${product.title}" style="display: none;">${product.title}</span>
                            <button data-lid="${lid}" data-purpose="delete" data-epi="${selectedVariant.id}" data-empi="${product.id}" data-du="${pdp.du}" class="${this.isShareWishlistPage && 'swym-hide-container'} swymcs-button swymcs-product-delete-btn swym-nav swym-nav-1 swym-is-button" aria-label="Delete ${product.title}">
                                <span class="swym-icon">${this.settings.swym_delete_list_icon}</span>
                            </button>
                            <div class="swymcs-wishlist-product-image-wrapper">
                                <img class="swymcs-wishlist-image" src="${imageSrc}" alt="${product.title}">
                            </div>
                            <button data-url="${pdp.du}" data-purpose="link" class="swymcs-product-link swym-is-button swymcs-button" aria-label="Visit ${product.title} page">
                                <div class="swymcs-product-title">${product.title}</div>
                            </button>
                            <div class="swymcs-variant-title swym-hide-container">${selectedVariant.title}</div>
                            <div class="swymcs-product-price">${currencyCode}${selectedVariant.price/100}/yard</div>
                            <textarea ${this.isShareWishlistPage && 'readonly'} data-purpose="note" placeholder="${!this.isShareWishlistPage ? this.settings.notes_placeholder_text : ''}" class="swymcs-product-note" data-lid="${lid}" data-position-index="${pdp?.cprops?.index}" data-epi="${selectedVariant.id}" data-empi="${product.id}" data-du="${pdp.du}" value="${pdp?.note || ''}">${pdp?.note || ''}</textarea>
                            <div class="swymcs-product-buttons">
                                <button ${isSoldOut ? 'disabled': ''} data-purpose="cart" data-du="${pdp.du}" data-epi="${selectedVariant.id}" data-empi="${product.id}" 
                                    class="${inCart} ${isSoldOut} swymcs-major-button swymcs-add-to-cart-btn swymcs-button" aria-label="${addToCartBtnText}">
                                    ${addToCartBtnText}
                                </button>
                                ${sampleVariantHtml}
                            </div>
                        </div>
                    </li>
                `;
            });
            this.productsContainer.innerHTML = productMarkup;
            this._scrollToTop();
        }

        _renderEmptyList(){
            this.productsContainer.innerHTML = window.emptyListContent;
            this.productsContainer.querySelector('#swym-empty-wishlist-container').classList.remove('swym-hide-container');
        }

        async _renderAdditionalOptionsPopup (evt) {
            const page = document.querySelector('swym-wishlist-page');
            const target = evt.target;
            if(target.id == 'swymcs-additional-options') return; 
            page._hidePopupContainer(page.querySelector('.swym-active-popup'));
            const action = target.dataset.action; 
            page._closeAdditionalOptionsPopup();
            if(action == 'share') page._renderShareList();
            else if(action == 'rename') page._renderRenameList();
            else if(action == 'duplicate') page._renderDuplicateList();
            else if(action == 'delete') page._renderDeleteList();
            if(window.productsDraged) await page._updateProductSequenceOfCurrentList();
        }

        _closeAdditionalOptionsPopup () {
            this._hideContainer(this.shareListPopup);
            this._hideContainer(this.renameListPopup);
            this._hideContainer(this.duplicateListPopup);
            this._hideContainer(this.deleteListPopup);
            this._hidePopupContainer(this.additionalOptionsPopupContainer);
        }

        async _renderShareList() {
            const list = await this._markListAsPublic();
            const shareableLink = await this._prepareShareLink(list);
            this.shareLinkField.textContent = shareableLink;
            this._showContainer(this.shareListPopup);
            this._showPopupContainer(this.additionalOptionsPopupContainer);
        }

        _renderRenameList () {
            this.renameListName.textContent = this.activeListTilte.textContent;
            this.renameListTextField.value = this.activeListTilte.textContent;
            this.renameListTextField.placeholder = this.activeListTilte.textContent;
            this._showContainer(this.renameListPopup);
            this._showPopupContainer(this.additionalOptionsPopupContainer);
        }

        _renderDuplicateList () {
            this.duplicateListName.textContent = this.activeListTilte.textContent;
            this.duplicateListTextField.value = 'Copy Of ' + this.activeListTilte.textContent;
            this.duplicateListTextField.placeholder = this.activeListTilte.textContent;
            this._showContainer(this.duplicateListPopup);
            this._showPopupContainer(this.additionalOptionsPopupContainer);
        }

        _renderDeleteList () {
            this.deleteListName.textContent = this.activeListTilte.textContent;
            this._showContainer(this.deleteListPopup);
            this._showPopupContainer(this.additionalOptionsPopupContainer);
        }

        /* Show / Hide containers */

        _overlayEvent(evt){
            if (evt.target.nodeName == 'BODY') {
                this.querySelectorAll(".swym-active-popup").forEach(popup => this._hidePopupContainer(popup));
            }
        }

        _scrollToTop () {
            const header = document.querySelector('.swymcs-page-header');
            if (header) {
                var targetOffsetTop = header.getBoundingClientRect().top + window.scrollY;
                window.scrollTo({
                    top: targetOffsetTop,
                    behavior: "smooth"
                });
            }
        }

        _showPopupContainer (selector) {
            selector.classList.remove('swym-hide-container');
            selector.classList.add('swym-active-popup');
            this.body.classList.add('no-scroll');
        }

        _hidePopupContainer (selector) {
            selector.classList.add('swym-hide-container');
            selector.classList.remove('swym-active-popup');
            this.body.classList.remove('no-scroll');
        }

        _showContainer (selector) {
            selector.classList.remove('swym-hide-container');
        }

        _hideContainer (selector) {
            selector.classList.add('swym-hide-container');
        } 

        /* Javascript APIs related functions */
        _getLists () {
            return new Promise(async (resolve, reject) => {
                this.swat.fetchLists({
                  callbackFn: lists => resolve(lists),
                  errorFn: err => reject(err)
                });
            });
        } 

        _getListDetails(lid){
            return new Promise(async (resolve, reject) => {
                this.swat.fetchListDetails(
                  { lid: lid },
                  list => resolve(list),
                  error => reject(error)
                );
            });
        }

        _getProductsFromList(lid){
            return new Promise(async (resolve, reject) => {
                this.swat.fetchListCtx(
                  { lid: lid },
                  listContents => resolve(listContents),
                  error => reject(error)
                );
            });
        }

        async _getShopifyProductsData(products){
            if(!products.length) return [];
            let res = await Promise.all(products.map(async (pdp) => {
                const productData = await fetch(pdp.du.split('?')[0] + '.js');
                const jsonData = await productData.json();
                return jsonData;
            }));
            return res;
        }

        _deleteProductFromList(product, lid, parentNode){
            const onSuccess = async deletedProduct => {
                parentNode.remove();
                if(!this.productsContainer.querySelector('li')){
                    this._renderProductsGrid([], []);
                }
                const lists = await this._getLists();
                const currentList = lists.filter(list => list.lid == lid);
                console.log(currentList, 'currentList');
                swymCustomFunctions._updateUnsortedLists(currentList);
            }
            const onError = error => console.log("Error while deleting the Product", error)
            this.swat.deleteFromList(lid, product, onSuccess, onError);
        }

        _renameList(){
            const listName = this.renameListTextField.value; 
            const isValidListName = this._validateListName(listName.trim().toLowerCase(), this.renameListError);
            if(!isValidListName) return;
            const listUpdateConfig = {
                "lid": window.currentActiveListId,
                "lname": listName,
                "lnote": ""
            };
            const onSuccess = async (updatedListObj) => {
                this._closeAdditionalOptionsPopup();
                this.lists = await this._getLists();
                this._renderListHeader(window.currentActiveListId);
            }
            const onError = error => console.log(`Error while Renaming the List, ${window.currentActiveListId}`, error);
            _swat.updateList(listUpdateConfig, onSuccess, onError);
        }

        _duplicateList(){
            const listName = this.duplicateListTextField.value; 
            const isValidListName = this._validateListName(listName.trim().toLowerCase(), this.duplicateListError);
            if(!isValidListName) return;
            const listConfig = {
                "lname": listName,
                "fromlid": window.currentActiveListId,
            };
            const onSuccess = async (listObj) => {
                this.lists = await this._getLists();
                this._renderListProducts(listObj.lid);
                this._closeAdditionalOptionsPopup();
            }
            const onError = error => console.log(`Error while duplicating the List, ${lid}`, error);
            _swat.createList(listConfig, onSuccess, onError);
        }

        _deleteList(){
            const onSuccess = deletedListObj => {
                this._closeAdditionalOptionsPopup();
                this._renderWishlist(_swat);
            }
            const onError = error => console.log(`Error while deleting the List, ${lid}`, error);
            _swat.deleteList(window.currentActiveListId, onSuccess, onError);
        }

        _validateListName(name, errorField){
            const isValidList = false;
            if(name.length < 3){
                errorField.textContent = 'Name must be longer than 3 characters';
                return isValidList; 
            }
            const lists = this.lists;
            const matchedList = lists.find(list => list.lname.trim().toLowerCase() == name);
            if(matchedList) {
                errorField.textContent = 'List name already exists';
                return isValidList;
            }
            errorField.textContent = '';
            return !isValidList;
        }

        _validateEmail() {
            const emailPattern = /^\w+([.-]\w+)*@\w+([.-]\w+)*(\.\w{2,4})+$/;
            const isBlank = this.shareEmailField.value=='' ? true : false;
            const isInvalidString = !this.shareEmailField.value.match(emailPattern) ? true : false;
            if(isBlank || isInvalidString){
                this.shareListError.textContent = isBlank ? 'Please enter the email address' : 'Please enter a valid email address';
                return false;
            }
            this.shareListError.textContent = '';
            return true;
        }

        _addProductToCart(button){
            const isSampleButton = button.classList.contains('swymcs-sample-product');
            if(isSampleButton) {
                const snipCount = +localStorage.getItem('snipCount');
                if(snipCount > 9) {
                    alert("You added max 10 snips");
                    return;
                }
            }
            const epi = +button.dataset.epi;
            const empi = +button.dataset.empi;
            const du = button.dataset.du;
            this.swat.replayAddToCart({
                empi,
                du,
                qty: 1
            }, epi, (c) => {
                const variant = JSON.parse(c).items[0];
                const productInCart = button.classList.contains('swymcs-product-in-cart');
                if(isSampleButton && variant && !productInCart){
                    const snipCount = +localStorage.getItem('snipCount');
                    localStorage.setItem('snipCount', snipCount+1);
                }
                button.classList.add('swymcs-product-in-cart');
                if(!isSampleButton) button.textContent = 'Added to cart'; 
                _cartRefresh();
            }, (error) => {
                button.textContent = 'Add to cart';
                button.removeAttribute('disabled');
                _swat.ui.uiRef.showErrorNotification({ message: error.description });
            }); 
        }

        _updateProductNote(product, lid) {
            const onSuccess = item => _swat.ui.uiRef.showSuccessNotification({
                message: `Note ${item.note ? 'added': 'deleted'} successfully for <strong>${item.dt}</strong>!`
            });
            const onError = err => _swat.ui.uiRef.showErrorNotification({ message: err.description });
            _swat.updateListItem(lid, product, onSuccess, onError);
        }

        _markListAsPublic(){
            return new Promise(async (resolve, reject) => {
                this.swat.markListPublic(window.currentActiveListId,
                    list => resolve(list),
                    err => reject(err)
                );
            });
        }

        _prepareShareLink(list){
            return new Promise(async (resolve, reject) => {
                this.swat.generateSharedListURL(list.lid,
                    (link, lid) => resolve(link, lid),
                    err => reject(err)
                );
            });
        }

        _shareListByCopy(){
            navigator.clipboard.writeText(this.shareLinkField.textContent)
            .then(() => _swat.ui.uiRef.showSuccessNotification({ message: 'Link Copied to Clipboard!' }))
            .catch(error => _swat.ui.uiRef.showErrorNotification({message: error.description}));
        }

        _shareListByEmail(){
            console.log('_shareListByEmail');
            const email = this._validateEmail();
            if(!email) return;
            const onSuccess = response => {
                _swat.ui.uiRef.showSuccessNotification({message: 'List shared successfully over mail'});
                this._closeAdditionalOptionsPopup();
            }
            const onError = error => _swat.ui.uiRef.showErrorNotification({message: error.description});
            _swat.sendListViaEmail({
                'toEmailId': this.shareEmailField.value.trim(),
                'note': this.shareMessageField.value,
                'fromName': this.shareNameField.value,
                'lid': window.currentActiveListId,
            }, onSuccess, onError);
        }

        _shareListOnPlatform(platform){
            const shareUrl = this.shareLinkField.textContent;
            const note = this.shareMessageField.value;
            const fromName = this.shareNameField.value;
            const onError = error => _swat.ui.uiRef.showErrorNotification({message: error.description});
            let platformShareUrlTemplate = '';
            if(platform == 'facebook') 
                platformShareUrlTemplate = `https://www.facebook.com/sharer.php?u=${shareUrl}&t=${note}`;
            else if(platform == 'twitter')  
                platformShareUrlTemplate = `https://twitter.com/share?text=${note}&url=${shareUrl}`; 
            _swat.shareListSocial(window.currentActiveListId, fromName, platformShareUrlTemplate, platform, note, onError)
        }

        /* Header functions */

        _loginButtonAction(evt){
            const redirectionUrl = evt.currentTarget.getAttribute('data-redirection-url');
            const actionUrl = evt.currentTarget.getAttribute('data-action-url');
            localStorage.setItem('SWYM_REDIRECT_URL', redirectionUrl);
            localStorage.setItem('SWYM_ACTION_URL', actionUrl);
            location.href = actionUrl;
        }

        async _switchListsFromHeader (evt){
            const page = document.querySelector('swym-wishlist-page');
            const lid = evt.target.dataset.lid;
            if(window.productsDraged) await page._updateProductSequenceOfCurrentList();
            page._renderListHeader(window.currentActiveListId);
            page._renderListProducts(lid);
            page._hidePopupContainer(page.headerListsContainer);
        }

        /* Product Grid Events */

        _manageDragEvent(){
            const sortable = new Sortable(this.productsContainer, {
                animation: 150, 
                onEnd: async (evt) => {
                    console.log('Product moved', evt.oldIndex, 'to', evt.newIndex);
                    window.productsDraged = true;
                }
            });
        }

        async _updateProductSequenceInList(seq){ 
            const lid = window.currentActiveListId;
            const listProducts = await this._getProductsFromList(lid);
            const sequenceMap = {};
            seq.forEach(item => {
                sequenceMap[item.epi] = item.index;
            });
            listProducts.forEach(product => {
                const epi = product.epi;
                if (epi in sequenceMap) {
                    product.cprops = product.cprops || {};
                    product.cprops.index = sequenceMap[epi];
                }
            });
            return listProducts;
        }
        
        async _eventsForProductsGrid (evt) {
            const target = evt.target;
            if(target.id == 'swymcs-products-grid') return;
            const purpose = target.dataset.purpose;
            const page = document.querySelector('swym-wishlist-page');
            if(purpose == 'cart'){
                page._addProductToCart(target)
            }else if (purpose == 'delete'){
                page._deleteProductFromList(
                    {
                        "epi": target.dataset.epi,
                        "empi": target.dataset.empi,
                        "du": target.dataset.du
                    }, target.dataset.lid, target.closest('li')
                );
            } else if(purpose == 'link'){
                if(!page.isShareWishlistPage) await page._updateProductSequenceOfCurrentList();
                const url = target.dataset.url;
                location.href = url;
            }else if(purpose == 'note'){
                if(evt.type=="change"){
                   page._updateProductNote({
                            'epi': target.dataset.epi,
                            'empi': target.dataset.empi,
                            'du': target.dataset.du,
                            'note': target.value.trim(),
                            'cprops': { 'index' : target.dataset.positionIndex }
                        }, target.dataset.lid
                    ); 
                }
            }
        }

        /* Additional Options */


    }
    customElements.define('swym-wishlist-page', SwymWishlistPage);
}